import Box from "@mui/material/Box";
import { ReactComponent as Bold01Icon } from "components/Icons/bold-01.svg";
import { ReactComponent as Code01Icon } from "components/Icons/code-01.svg";
import { ReactComponent as CornerUpLeftIcon } from "components/Icons/corner-up-left.svg";
import { ReactComponent as CornerUpRightIcon } from "components/Icons/corner-up-right.svg";
import { ReactComponent as Dotpoints01Icon } from "components/Icons/dotpoints-01.svg";
import { ReactComponent as EraserIcon } from "components/Icons/eraser.svg";
import { ReactComponent as H1Icon } from "components/Icons/h1.svg";
import { ReactComponent as Italic01Icon } from "components/Icons/italic-01.svg";
import { ReactComponent as Link03Icon } from "components/Icons/link-03.svg";
import { ReactComponent as Numberedlist01Icon } from "components/Icons/numberedlist-01.svg";
import { ReactComponent as Strikethrough01Icon } from "components/Icons/strikethrough-01.svg";
import { ReactComponent as Underline01Icon } from "components/Icons/underline-01.svg";
import { useCallback } from "react";
import { useStyles } from "./TextEditor.styles";

export const MenuBar = ({ editor }: any) => {
  const classes = useStyles();

  const setLink = useCallback(() => {
    const previousUrl = editor.getAttributes("link").href;
    const url = window.prompt("URL", previousUrl);

    switch (url) {
      case null:
        return;
      case "":
        return editor.chain().focus().extendMarkRange("link").unsetLink().run();
      default:
        return editor
          .chain()
          .focus()
          .extendMarkRange("link")
          .setLink({ href: url })
          .run();
    }
  }, [editor]);

  if (!editor) {
    return null;
  }

  return (
    <Box className={classes.menuBar}>
      <Box className={classes.buttonsGroup}>
        <button
          type="button"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 1 }).run()
          }
          className={`${classes.menuBarButton} ${
            editor.isActive("heading", { level: 1 }) ? classes.isActive : ""
          }`}
        >
          <H1Icon className={classes.icon} />
        </button>
        <div className={classes.verticalLine} />
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBold().run()}
          disabled={!editor.can().chain().focus().toggleBold().run()}
          className={`${classes.menuBarButton} ${
            editor.isActive("bold") ? classes.isActive : ""
          }`}
        >
          <Bold01Icon className={`${classes.icon} ${classes.strokeMedium}`} />
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleItalic().run()}
          disabled={!editor.can().chain().focus().toggleItalic().run()}
          className={`${classes.menuBarButton} ${
            editor.isActive("italic") ? classes.isActive : ""
          }`}
        >
          <Italic01Icon className={classes.icon} />
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          disabled={!editor.can().chain().focus().toggleUnderline().run()}
          className={`${classes.menuBarButton} ${
            editor.isActive("underline") ? classes.isActive : ""
          }`}
        >
          <Underline01Icon className={classes.icon} />
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleStrike().run()}
          disabled={!editor.can().chain().focus().toggleStrike().run()}
          className={`${classes.menuBarButton} ${
            editor.isActive("strike") ? classes.isActive : ""
          }`}
        >
          <Strikethrough01Icon className={classes.icon} />
        </button>
        <div className={classes.verticalLine} />
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={`${classes.menuBarButton} ${
            editor.isActive("bulletList") ? classes.isActive : ""
          }`}
        >
          <Dotpoints01Icon className={classes.icon} />
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={`${classes.menuBarButton} ${
            editor.isActive("orderedList") ? classes.isActive : ""
          }`}
        >
          <Numberedlist01Icon className={classes.icon} />
        </button>
        <div className={classes.verticalLine} />
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleCode().run()}
          disabled={!editor.can().chain().focus().toggleCode().run()}
          className={`${classes.menuBarButton} ${
            editor.isActive("code") ? classes.isActive : ""
          }`}
        >
          <Code01Icon className={classes.icon} />
        </button>
        <button
          type="button"
          onClick={setLink}
          className={`${classes.menuBarButton} ${
            editor.isActive("link") ? "isActive" : ""
          }`}
        >
          <Link03Icon className={classes.icon} />
        </button>
        <div className={classes.verticalLine} />
        <button
          type="button"
          onClick={() => {
            const docSize = editor.state.doc.content.size;
            const { from } = editor.state.selection;

            editor
              .chain()
              .focus()
              .setTextSelection({ from: 0, to: docSize })
              .clearNodes()
              .unsetAllMarks()
              .setTextSelection(from)
              .run();
          }}
          className={`${classes.menuBarButton}`}
        >
          <EraserIcon className={`${classes.icon} ${classes.strokeMedium}`} />
        </button>
      </Box>
      <Box className={classes.buttonsGroup}>
        <div className={classes.verticalLine} />
        <button
          type="button"
          onClick={() => editor.chain().focus().undo().run()}
          disabled={!editor.can().chain().focus().undo().run()}
          className={classes.menuBarButton}
        >
          <CornerUpLeftIcon className={classes.icon} />
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().redo().run()}
          disabled={!editor.can().chain().focus().redo().run()}
          className={classes.menuBarButton}
        >
          <CornerUpRightIcon className={classes.icon} />
        </button>
      </Box>
    </Box>
  );
};
